import {EAccountOperationActions, GetAccountOperations, GetAccountOperationsFailure, GetAccountOperationsSuccess} from "../../actions/accounting/account-operations.actions";
import {IAccountOperation} from "../../models/accounting/accounting.interface";
import {Actions, createEffect, Effect, ofType} from "@ngrx/effects";
import {IAppState} from "../../state/app.state";
import {Store} from "@ngrx/store";
import {AccountingService} from "../../services/accounting.service";
import {Injectable} from "@angular/core";
import {catchError, map, switchMap, withLatestFrom} from "rxjs/operators";
import {of} from "rxjs";


@Injectable()
export class AccountOperationsEffects {

  Operations$ =  createEffect(() => this._actions$.pipe(
    ofType<GetAccountOperations>(EAccountOperationActions.GetAccountOperations),
    withLatestFrom(this._store$),
    switchMap(([action, storeState]) =>{
      return this._accountingService.getAccountOperations(storeState.authentication.data.accessToken, action.payload)
        .pipe(
          map(
            result =>{
              console.log('GetAccountOperations effect');

              const accountOperations:Array<IAccountOperation> = [];
              result['report'].forEach((item) =>{
                const operation:IAccountOperation = {
                  id: item['id'],
                  code: item['operation_type'],
                  accountId: item['account_id'],
                  date: item['date'],
                  parentId: item['parent_id'],
                  direction: item['transaction_type'],
                  status: item['status'],
                  name: item[''],
                  description: item[''],
                  amount: item['amount'],
                  stornoAmount:item['storno_amount'],
                  isStorno: item['']===1? true:false
                };
                switch (item['operation_type']){
                  case 'ACCRUE_BONUS':
                    operation.name = item['profile']['bonus']['accrual_type_description'];
                    operation.description = item['profile']['bonus']['description'];
                    break;
                  case 'WRITEOFF_BONUS':
                    operation.name = item['profile']['bonus']['accrual_type_description'];
                    operation.description = item['profile']['bonus']['description'];
                    break;
                }
                accountOperations.push(operation);
              });

              return new GetAccountOperationsSuccess(accountOperations);
            },
            catchError(error => {
              console.log(error);
              return of(new GetAccountOperationsFailure());
            })
          )
        );
      }
    )
  ));

  constructor(
    private _accountingService: AccountingService,
    private _actions$: Actions,
    private _store$: Store<IAppState>
  ) {}

}
